"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timeline = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Timeline = ({ colour = "#E6E6E6", size = 16, }) => (react_1.default.createElement(Base_1.Base, { size: size, stroke: colour },
    react_1.default.createElement("path", { d: "M1 1v4m14-4v4M8 2v3M4.5 3v2m7-2v2" }),
    react_1.default.createElement("path", { strokeWidth: "3", d: "M.5 8h3m1 0h11M.5 12h11m1 0h3" })));
exports.Timeline = Timeline;
//# sourceMappingURL=Timeline.js.map